import React, { useState, useCallback, useMemo } from "react";
import DataTable from "react-data-table-component";
import { Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import useExcluirDemonstrativo from "../hooks/useExcluirDemonstrativo";
import constants from "../../../Constants";

const getColumns = (tipoDetalhamento) =>
  [
    tipoDetalhamento !== "BY" &&
      tipoDetalhamento !== "BZ" &&
      tipoDetalhamento !== "B2" &&
      tipoDetalhamento !== "B3" &&
      tipoDetalhamento !== "B4" && {
        name: <div>Nº Nota</div>,
        selector: (row) => row.nuNotaSerie,
        maxWidth: "5%",
        center: true,
      },
    tipoDetalhamento !== "BY" && tipoDetalhamento !== "BZ"
      ? {
          name: <div>Chave/TADF</div>,
          cell: (row) => (
            <div
              title={row.txChave}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {row.txChave}
            </div>
          ),
          style: {
            maxWidth:
              tipoDetalhamento === "B2" || tipoDetalhamento === "B3" || tipoDetalhamento !== "B4" ? "27%" : "15%",
          },
        }
      : {
          name: <div>Origem do débito</div>,
          cell: (row) => (
            <div
              title={row.numPedido}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {row.numPedido}
            </div>
          ),
          center: true,
          style: { maxWidth: "15%" },
        },
    tipoDetalhamento !== "B2" &&
      tipoDetalhamento !== "B3" &&
      tipoDetalhamento !== "B4" && {
        name: <div>{tipoDetalhamento === "BY" || tipoDetalhamento === "BZ" ? "Numeração do Selo " : "Documento"}</div>,
        selector: (row) => (tipoDetalhamento === "BY" || tipoDetalhamento === "BZ" ? row.numSelo : row.documento),
        maxWidth: tipoDetalhamento === "BY" || tipoDetalhamento === "BZ" ? "20%" : "15%",
        center: true,
      },
    {
      name: "Código de Receita",
      maxWidth: tipoDetalhamento === "B3" || tipoDetalhamento === "B4" ? "25%" : "15%",
      center: true,
      cell: (row) => {
        const texto = row?.sgCodigoReceita ? `${row.sgCodigoReceita} - ${row.nmCodigoReceita}` : "";

        return (
          <div
            title={texto}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {texto}
          </div>
        );
      },
    },
    tipoDetalhamento === "B2" && {
      name: <div>Descrição do Débito</div>,
      selector: (row) => <div dangerouslySetInnerHTML={{ __html: row.dsItem }} />,
      maxWidth: "15%",
      center: true,
    },
    tipoDetalhamento !== "B2" &&
      tipoDetalhamento !== "B3" &&
      tipoDetalhamento !== "B4" &&
      tipoDetalhamento !== "BY" &&
      tipoDetalhamento !== "BZ" && {
        name: <div>Valor Operação (R$)</div>,
        maxWidth: "10%",
        selector: (row) =>
          row.vlNotaFiscal
            ? row.vlNotaFiscal.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        center: true,
      },
    tipoDetalhamento !== "B2" &&
      tipoDetalhamento !== "B3" &&
      tipoDetalhamento !== "B4" &&
      tipoDetalhamento !== "BY" &&
      tipoDetalhamento !== "BZ" && {
        name: "UF",
        selector: (row) => row.siglaUf,
        maxWidth: "5%",
        center: true,
      },
    {
      name: "Referência",
      selector: (row) => <DateTime value={row.dtReferenciaDebito} stringFormat="MM/yyyy" />,
      maxWidth: "9%",
      center: true,
    },
    {
      name: "Data de Vencimento",
      selector: (row) => <DateTime value={row.dtVencimentoDebito} stringFormat="dd/MM/yyyy" />,
      maxWidth: "9%",
      center: true,
    },
    (tipoDetalhamento === "BY" || tipoDetalhamento === "BZ") && {
      name: "Data da Geração",
      selector: (row) => <DateTime value={row.dtEmissao} stringFormat="dd/MM/yyyy" />,
      maxWidth: "9%",
      center: true,
    },
    {
      name: <div>ICMS a Recolher (R$)</div>,
      selector: (row) =>
        row.vlIcms
          ? row.vlIcms.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      center: true,
      maxWidth: "10%",
    },
    {
      name: "Multa (R$)",
      selector: (row) =>
        row.vlIcms
          ? row.vlMultaOcorrenciaAtual.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      center: true,
      maxWidth: "10%",
    },
    {
      name: "Total (R$)",
      selector: (row) =>
        (row.vlIcms + row.vlMultaOcorrenciaAtual).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      center: true,
      maxWidth: "10%",
    },
  ].filter(Boolean);

const conditionalRowStyles = [
  {
    when: (row) => row.nuNotaSerie === "Total",
    style: {
      backgroundColor: "#f0f0f0",
      cursor: "not-allowed",
      fontWeight: "bold", // Deixa a fonte em negrito
      color: "#333", // (opcional) ajusta a cor da fonte pra ficar mais visível
    },
  },
];
const ListagemDebitoExtrato = ({ sqItemOcorrencia, sqAcaoFiscal, tipoDetalhamento }) => {
  const [reload, setReload] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [itensSelecionados, setItensSelecionados] = useState([]);
  const { dataWithTotal, totalRows, isLoading, handlePageChange } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia, // Passando para o hook para atualizar os dados
    reload,
  });

  const { ModalExcluirDemonstrativo, setShowExcluirConfirm } = useExcluirDemonstrativo({
    setReload,
    setItensSelecionados,
  });

  const columns = useMemo(() => getColumns(tipoDetalhamento), [tipoDetalhamento]);

  const preparaDelete = useCallback(() => {
    if (itensSelecionados.length > 0) {
      setShowExcluirConfirm({
        show: true,
        body: `Confirma exclusão do(s) item(ns) no demonstrativo?`,
        context: { sqAcaoFiscal, sqItemOcorrencia, listaItens: itensSelecionados },
      });

      // Resetando a seleção e forçando novo fetch dos dados
      setClearSelectedRows(!clearSelectedRows);
      setItensSelecionados([]);

      // Força o reload completo para pegar os dados atualizados
      setReload((prev) => !prev);
    } else {
      document.getElementById("alerta").innerHTML = "Selecione pelo menos 1 item para excluir";
    }
  }, [itensSelecionados, sqAcaoFiscal, sqItemOcorrencia, setShowExcluirConfirm, clearSelectedRows]);

  return (
    <>
      {ModalExcluirDemonstrativo}
      <DataTable
        noHeader
        keyField={(row, index) => `${row.sqItemOcorrencia}-${index}`}
        columns={columns}
        data={dataWithTotal}
        progressPending={isLoading}
        noDataComponent="Nenhum registro para exibir"
        progressComponent={<TextSpinner />}
        pointerOnHover
        conditionalRowStyles={conditionalRowStyles}
        pagination
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        paginationComponentOptions={constants.paginationComponentOptions}
        paginationRowsPerPageOptions={[10, 20, 50, 100, 1000]}
        paginationPerPage={10} // Garante que o DataTable também respeite isso
        selectableRows
        selectableRowDisabled={(row) => row.nuNotaSerie === "Total"}
        selectableRowsVisibleOnly={(row) => !(row.nuNotaSerie === "Total")}
        onSelectedRowsChange={(state) => {
          setItensSelecionados(state.selectedRows);
        }}
        clearSelectedRows={clearSelectedRows}
      />

      <span className="alerta" hidden={itensSelecionados.length > 0} id="alerta">
        &nbsp;
      </span>

      <br />
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-chave">Excluir itens do demonstrativo</Tooltip>}>
        <Button
          className="btn btn-primary btn-md mt-1" // btn btn-primary btn-md mr-2 btn btn-primary
          style={{ marginTop: "3px" }} // CSS inline direto
          disabled={!itensSelecionados.length}
          onClick={() => preparaDelete()}
        >
          Excluir
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default ListagemDebitoExtrato;
